<template>
    <div
        @keyup.esc.stop="closeOutsideEsc"
        tabindex="0"
        ref="modal"
        class="fixed z-30"
    >
        <transition
            enter-active-class="ease-in-out duration-300"
            enter-class="opacity-0"
            enter-to-class="opacity-100"
            leave-active-class="ease-in-out duration-300"
            leave-class="opacity-100"
            leave-to-class="opacity-0"
            @after-enter="afterEnter"
        >
            <div v-if="showModal" class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden z-50">
                    <div
                        class="absolute inset-0 bg-gray-800 bg-opacity-75 transition-opacity"
                        aria-hidden="true"
                    ></div>
                </div>
            </div>
        </transition>

        <transition
            enter-active-class="transform transition ease-in-out duration-300 sm:duration-300"
            enter-class="opacity-0 translate-y-6"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transform transition ease-in-out duration-300 sm:duration-300"
            leave-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-6"
        >
            <div
                v-if="showModal"
                class="fixed inset-0 flex items-center justify-center overflow-hidden roatel-modal"
            >
                <div
                    v-click-outside.stop="closeOutsideEsc"
                    class="rounded-lg border-r-gray-light absolute flex flex-col overflow-hidden bg-white shadow-lg"
                    :class="[width, height]"
                >
                    <div
                        class="relative flex flex-row items-center justify-between px-4 pt-4 pb-4 md:px-8 md:pt-6 md:pb-4"
                    >
                        <div class="text-lg font-bold">
                            <slot name="title" :model="model">
                                <!-- Confirmation -->
                            </slot>
                        </div>
                        <div class="absolute right-2 top-2">
                            <button
                                v-if="showHideButton"
                                class="text-r-black focus:outline-none focus:ring-2 focus:ring-white group"
                                @click.stop="close"
                            >
                                <span class="sr-only">Close modal</span>
                                <icon
                                    icon="circle-x"
                                    class="stroke-r-gray-medium w-8 h-8 hover:stroke-r-green"
                                ></icon>
                                <!-- <font-awesome-icon -->
                                <!--     :icon="['far', 'circle-xmark']" -->
                                <!--     class="mr-2 text-2xl" -->
                                <!-- ></font-awesome-icon> -->
                            </button>
                        </div>
                    </div>
                    <div
                        class="px-4 pb-4 md:px-8 md:pb-6 text-base overflow-visible"
                    >
                        <slot name="body" :model="model"> Body </slot>
                    </div>
                    <div
                        class="px-4 py-4 bg-gray-50 md:py-3 md:px-8"
                        v-if="$scopedSlots.footer"
                    >
                        <slot name="footer" :model="model"></slot>
                    </div>
                    <div
                        v-if="isConfirmation"
                        class="py-5 flex-col-reverse flex md:flex-row items-center justify-between px-3 md:py-6 md:px-8 bg-r-gray-ultralight gap-5 md:gap-10"
                    >
                        <slot name="actions" :prop="model">
                            <div>
                                <app-button
                                    :icon="cancelIcon"
                                    :color="cancelColor"
                                    :outline="cancelOutline"
                                    :size="cancelSize"
                                    @click="close"
                                >
                                    {{ cancelLabel }}
                                </app-button>
                            </div>
                            <div>
                                <app-button
                                    :icon="confirmIcon"
                                    :color="confirmColor"
                                    :size="confirmSize"
                                    :outline="confirmOutline"
                                    @click="confirm"
                                >
                                    {{ confirmLabel }}
                                </app-button>
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import AppButton from "@guest/common/Button";
import Icon from "@guest/common/Icon";
import ClipContainer from "@guest/common/ClipContainer";
import * as vClickOutside from "v-click-outside-x";

export default {
    directives: {
        clickOutside: vClickOutside.directive,
    },
    components: {
        Icon,
        AppButton,
        ClipContainer,
    },
    data() {
        return {
            showModal: false,
            title: null,
            model: {},
        };
    },
    methods: {
        afterEnter() {
            console.log("after enter");
            this.$refs.modal.focus();
        },
        closeOutsideEsc() {
            if (this.isClickOutsideEnabled) {
                this.close();
            }
        },
        close() {
            this.showModal = false;
            this.$emit("closed", this.model);
        },
        confirm() {
            this.showModal = false;
            this.$emit("confirmed", this.model);
        },
        show(model, clone = false) {
            console.log("Modal show method", model, clone);
            this.model = model;
            if (clone) {
                this.model = _.cloneDeep(model);
            }
            this.showModal = true;
            console.log("Modal showModal property", this.showModal);
        },
    },
    mounted() {},
    watch: {},
    props: {
        //model: {
        //required: false,
        //default: () => {},
        //},
        confirmLabel: {
            required: false,
            default: "Löschen",
        },
        confirmIcon: {
            required: false,
            default: "save",
        },
        confirmColor: {
            required: false,
            default: "red",
        },
        confirmOutline: {
            required: false,
            default: false,
        },
        confirmSize: {
            required: false,
            default: "normal",
        },
        cancelLabel: {
            required: false,
            default: "Abbrechen",
        },
        cancelIcon: {
            required: false,
            default: "cancel",
        },
        cancelOutline: {
            required: false,
            default: true,
        },
        cancelColor: {
            required: false,
            default: "gray",
        },
        cancelSize: {
            required: false,
            default: "normal",
        },
        width: {
            required: false,
            default: "w-1/2 xl:w-1/3",
        },
        height: {
            required: false,
            default: "min-h-1/5",
        },
        isConfirmation: {
            required: false,
            default: false,
        },
        isClickOutsideEnabled: {
            default: true,
        },
        showHideButton: {
            default: true,
        },
    },
};
</script>

<style></style>
